import {useStore} from '../../../store/store';
import PageWrapper from '../../modules/PageWrapper';
import React, {useEffect} from 'react';
import {observer} from 'mobx-react';
import {getCrmRedirectOrigin} from './crmRedirect';

const CRMWrapper = () => {
  return (
    <PageWrapper
      breadcrumbs={[
        {title: 'Panely', path: ''},
        {isSeparator: true},
        {title: 'CRM', path: '/crm', isActive: true},
      ]}
      title={'CRM'}
    >
      <CRM />
    </PageWrapper>
  );
};

const CRM = observer(({isVerify}) => {
  const store = useStore();

  useEffect(() => {
    if (isVerify && store.user.main_token) {
      const redirect = new URLSearchParams(window.location.search).get('redirect');
      const redirectOrigin = getCrmRedirectOrigin(redirect);
      const token = encodeURIComponent(store.user.main_token);

      window.location.href = `${redirectOrigin}/verify/${token}`;
    }
  }, [isVerify, store.user.main_token]);

  return <></>;
});

export default CRMWrapper;
